import(/* webpackMode: "eager" */ "/vercel/path0/apps/storefront/app/[lang]/error.tsx");
